
export const data = [
	{
		to: '/',
		text: 'Početna',
		id: 'about',
	},
	{
		to: '/pricing',
		text: 'Pravna područja',
	},
	{
		to: '/signup',
		text: 'Kontakt',
	},
];



export const logoData = {
img: "./assets/scale.png"

}
